import React, { useEffect, useState, useRef } from "react";
import { withApiContext, withLabelsContext, withUserContext } from "context";
import {
  IconBotSimplifi,
  RefreshIcon,
  IconPublishCourse,
  IconCertified,
  IconClosed
} from "Icons";
import { Col, Row, Button } from "react-bootstrap";
import BotModal from "./BotModel";
import CourseTestList from "./CourseList";
import FormField from "components/FormField";
import { Select } from "components";
import FormDateRangePicker from "components/FormDateRangePicker/FormDateRangePicker";
import "./SimplifiBot.css";
import { StyledChatMessages, StyledChatInterface, StyledChatHeader } from "./SimplifiBot.styles";


function formatIndianDateTime(date) {
  if (!(date instanceof Date) || isNaN(date)) return "";

  const day = String(date.getDate()).padStart(2, "0");
  const monthNames = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();
  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;
  return `${day}-${month}-${year} ${String(hours).padStart(2, "0")}:${minutes} ${ampm}`;
}

function SimplifiBot(props) {
  // --- Modal & Publish Toggles ---
  const [isModalOpen, setModalOpen] = useState(true);
  const [isCoursePublish, setCoursePublish] = useState(false);
  const [isTestPublish, setTestPublish] = useState(false);
  const [isPublish, setIsPublish] = useState(false);

  // --- Course/Test State ---
  const [courseList, setCourseList] = useState([]);
  const [allCourses, setAllCourses] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState(false);
  const [selectedDetails, setSelectedDetails] = useState([]);
  const [courseName, setCourseName] = useState("");

  // --- Standard/Subject/Batch ---
  const [standard, setStandard] = useState([]);
  const [publishType, setPublishType] = useState("");
  const [showSelect, setShowSelect] = useState(false);
  const [showpubType, setShowpubType] = useState(false);
  const [classOptions, setClassOptions] = useState([]);

  // --- Toggles ---
  const [download, setDownload] = useState(false);
  const [seekable, setSeekable] = useState(false);
  const [summary, setSummary] = useState(false);
  const [assessmentSummary, setAssessmentSummary] = useState(false);
  const [timeSettings, setTimeSettings] = useState(false);
  const [duration, setDuration] = useState(false);
  const [certificate, setCertificate] = useState(false);

  // --- Date ---
  const [fromDate, setFromDate] = useState(() => formatIndianDateTime(new Date()));

  // --- Pagination ---
  const [pageIndex, setPageIndex] = useState(1);
  const [showList, setShowList] = useState(false);
  const prevPageIndex = useRef(pageIndex);
  const [publishDetails,setPublishDetails] = useState([]);
  const [alert,setAlert] = useState(false);
  const [seeMore,setSeeMore] = useState(false);
  // --- User Data ---
  const standards = props.ctx_user.user.campusCategories;
  const subjects = props.ctx_user.user.campusSubj;

  // --- Effects ---
  useEffect(() => {
    if (standard.standard && standard.subject) fetchCourse();
  }, [standard.standard, standard.subject]);

  useEffect(() => {
    if (pageIndex > 1 && prevPageIndex.current !== pageIndex) fetchCourse();
    prevPageIndex.current = pageIndex;
  }, [pageIndex]);

  useEffect(() => {
    if (showpubType) {
      const options =
        showpubType.org_hierarchy?.map((item) => ({
          label: item.label,
          value: item.value,
        })) || [];
      setClassOptions(options);
    }
  }, [showpubType]);

  // --- Handlers ---
  const handleCourseClick = () => setCoursePublish(prev => !prev);
  const handleTestClick = () => setTestPublish(prev => !prev);

 const handleChange = ({ name, value }) => {
  if (name === "endDate") {
    const now = new Date();
    const selectedDate = new Date(value);

    const isInvalid =
      selectedDate < now ||
      (selectedDate.toDateString() === now.toDateString() && selectedDate <= now);

    if (isInvalid) {
      setAlert(true);   // show error
    } else {
      setAlert(false);  // clear error when valid date is chosen
      setStandard((prevStandard) => ({
        ...prevStandard,
        [name]: value,
      }));
    }
  } else {
    // normal case for other fields
    setStandard((prevStandard) => ({
      ...prevStandard,
      [name]: value,
    }));
  }
};


  const handleSelectedCourse = course => {
    setSelectedCourse(course);
    fetchCourseDetails(course);
  };
  const handleCourseName = (course) => {
    setCourseName(course);
    fetchCourse()
  }
  const fetchCourseDetails = async entity => {
    const cmd = isCoursePublish ? "get_master_course_details" : "get_test_dtl";
    const args = { [isCoursePublish ? "courseId" : "testId"]: entity.id,
      isAdaptive: 0,
     };
    try {
      const { rsp } = await props.ctx_api.privateRequest({ cmd, args });
      if (rsp) setSelectedDetails(rsp);
    } catch (err) {
      console.error("Error fetching details:", err);
    }
  };

  const fetchCourse = async () => {
    try {
      const { rsp } = await props.ctx_api.privateRequest({
        cmd: "get_course_test_with_pagination",
        args: {
          name: courseName,
          typeFlag: isCoursePublish ? 0 : 1,
          pageSize: 10,
          pageIndex,
          curriculumId: standard.subject,
          standardId: standard.standard,
        },
      });
      if (rsp.length > 0) {
        setCourseList(rsp);
        setAllCourses(prev => [
          ...prev,
          ...rsp.filter(item => !prev.some(e => e.id === item.id)),
        ]);
        setShowList(true);
      }
      else {
        setSeeMore(true)
      }
    } catch (err) {
      console.error("Error fetching courses:", err);
    }
  };

  const fetchclassList = async pubType => {
    setPublishType(pubType);
    const { rsp } = await props.ctx_api.privateRequestRow({
      cmd: "get_member_tree_list",
      args: { pubType: pubType === "class" ? "1" : "2" },
    });
    if (rsp) {
      setShowSelect(true);
      setShowpubType(rsp);
    }
  };

  const handleCancel = () => {
    setCoursePublish(false);
    setTestPublish(false);
    setCourseList([]);
    setStandard([]);
    setSelectedCourse(false);
    setShowSelect(false);
    setShowpubType(false);
    setClassOptions([]);
    setPublishType("");
    setCourseName("");
    setPageIndex(1);
    setShowList(false);
    setAllCourses([]);
    setSelectedDetails([]);
    setIsPublish(false);
    setPublishDetails([])
  };

  // --- Toggle Functions ---
  const toggleDownload = () => setDownload(prev => !prev);
  const toggleSeekable = () => setSeekable(prev => !prev);
  const toggleSummary = () => setSummary(prev => !prev);
  const toggleAssessmentSummary = () => setAssessmentSummary(prev => !prev);
  const toggleTimeSettings = () => {
    setTimeSettings(prev => {
      const newVal = !prev;
      setDuration(newVal);
      return newVal;
    });
  };

  // --- Publish ---
const coursePublish = async () => {
  let newCourseList = [];
  console.log(selectedDetails);

  newCourseList = selectedDetails[0].content_details
    ? selectedDetails[0].content_details.map((item) => {
        return {
          name: item.name,
          chapter_id: item.content_id,
          releaseDate: item.created_on,
        };
      })
    : [];

  const args = {
    coursePubId: "0",
    fromDate: fromDate,
    toDate: standard.endDate,
    hasCertificate: 0,
    displayCard: 0,
    trainerIds: [props.ctx_user.user.id],
    courseId: selectedCourse.id,
    coursePubName: selectedCourse.name,
    topicReleaseType: 4,
    topicReleasePattern: null,
    numbDays: null,
    topicReleaseTime: null,
    topicReleaseTimeWeekly: null,
    pubWeek: null,
    weekDays: [],
    library: 0,
    seqContent: 1,
    deliveryType: "C",
    serviceProviderId: null,
    enrollDate: null,
    maxStud: null,
    selfReg: 0,
    mangApp: 0,
    waitlistAllow: 0,
    pubType: publishType,
    allocation:
      publishType === "class"
        ? JSON.stringify({ members: [standard.class], properties: {} })
        : JSON.stringify({ members: [standard.batch], properties: {} }),
    topicList: JSON.stringify(newCourseList),
    seekable: seekable ? 1 : 0,
    certificate_assigned_type: 0,
    groupName: "",
    sequence: "",
    notification: 0,
    downloadContent: download ? 1 : 0,
    description: selectedDetails[0].description,
    multicourse: 0,
    naContent: "0",
    summaryViewable: [],
    isNonAcad: [],
    certificateConfigId: null,
    testCertificate: null,
    testPercentage: null,
  };

  try {
    const { rsp } = await props.ctx_api.privateRequest({
      cmd: "insert_update_course_publish_v2",
      args,
    });

    if (rsp) {
      const standardMatch = standards.find((s) => s.value === standard.standard);
      const subjectMatch = subjects.find((s) => s.value === standard.subject);
      const standardClassMatch = showpubType.org_hierarchy.find((s) => s.value === standard.class);
      const standardBatchMatch = showpubType.org_hierarchy.find((s) => s.value === standard.batch);
      setIsPublish(true);
       setPublishDetails({
        title: selectedCourse.name,
        fromDate: fromDate,
        endDate: standard.endDate,
         standard: standardMatch.label || "",
        subject: subjectMatch.label || "",
        audience: publishType === "class" ? standardClassMatch.label : standardBatchMatch.label,
      });
    }
  } catch (err) {
    console.error(err);
  }
};


  const testPublish = async () => {
    if (!selectedDetails.length) return;

    const args = {
      publishTestId: 0,
      status: "1",
      duration: standard.duration?.toString(),
      testId: selectedCourse.id,
      testName: selectedDetails[0].name,
      testShortName: selectedDetails[0].identifier,
      from: fromDate,
      to: standard.endDate,
      testTotalMark: selectedDetails[0].credit,
      categoryId: standard.standard?.toString(),
      testCategoryId: standard.standard?.toString(),
      classId: "0",
      classIds: publishType === "class" ? [standard.class].join(",") : "",
      batchIds: publishType === "batch" ? [standard.batch].join(",") : "",
      classPubIds: publishType === "class" ? [[standard.class].join(",") ]: [],
      studentsIds: "",
      studentsPubIds: [],
      poolCount: "0",
      randQuestion: 0,
      scoreType: 0,
      randSection: 0,
      coursePublishId: null,
      courseId: null,
       fromClassView: 0,
       description: "",
       type: timeSettings ? 1 : 0,
      testCurriculumId: selectedDetails[0].curriculum_id,
      testType: "N",
      questionPool: 0,
      selection: publishType,
      attempts: standard.attempt,
      description: selectedDetails[0].description,
      summary_viewable: summary ? 1 : 0,
      summary_report:  0,
      hasCertificate: 0,
       certificateConfigId: null,
       testPercentage: null,
        checkbx: 0,
        aiproctor:0,
    };

    try {
      const { rsp } = await props.ctx_api.privateRequest({
        cmd: "insert_update_publish_test_v2",
        args,
      });
      if (rsp) {
        setIsPublish(true);
         const standardMatch = standards.find((s) => s.value === standard.standard);
      const subjectMatch = subjects.find((s) => s.value === standard.subject);
      const standardClassMatch = showpubType.org_hierarchy.find((s) => s.value === standard.class);
      const standardBatchMatch = showpubType.org_hierarchy.find((s) => s.value === standard.batch);
       setPublishDetails({
        title: selectedCourse.name,
        fromDate: fromDate,
        endDate: standard.endDate,
         standard: standardMatch.label || "",
        subject: subjectMatch.label || "",
        audience: publishType === "class" ? standardClassMatch.label : standardBatchMatch.label,
      });
      }

    } catch (err) {
      console.error(err);
    }
  };

  // --- Render Helpers ---
  const handleCombination = () => (
    <Row>
      <Col md={6}>
        <FormField
        className="publish-btns"
          type={Select}
          name="standard"
          options={standards}
          onChange={handleChange}
          value={standard.standard}
          placeholder="Choose Standard"
          disabled={selectedCourse}
          required
          isBot
        />
      </Col>
      <Col md={6}>
        <FormField
         className="publish-btns"
          type={Select}
          name="subject"
          options={subjects}
          onChange={handleChange}
          value={standard.subject}
          disabled={selectedCourse}
          placeholder="Choose Subject"
          required
        />
      </Col>
    </Row>
  );

  const handleSelectBatch = () => (
    <Row>
      <Col md={5}>
        {(!publishType || publishType === "class") && (
          <FormField
          className="publish-btns"
            type={Select}
            name="class"
            options={classOptions}
            onMenuOpen={() => fetchclassList("class")}
            onChange={handleChange}
            value={standard.class}
            placeholder="Choose Class"
            required
          />
        )}
      </Col>
      <Col md={2}>{publishType === "" ? "OR" : ""}</Col>
      <Col md={5}>
        {(!publishType || publishType === "batch") && (
          <FormField
          className="publish-btns"
            type={Select}
            name="batch"
            options={classOptions}
            onMenuOpen={() => fetchclassList("batch")}
            onChange={handleChange}
            value={standard.batch}
            placeholder="Choose Batch"
            required
          />
        )}
      </Col>
    </Row>
  );

   const renderCertificate = () => {

     const options = [
      { label: props.ctx_labels.singular.one, value: 1 },
      { label: props.ctx_labels.singular.two, value: 2 },
      { label: props.ctx_labels.singular.three, value: 3 },
    ];

     const durations = [
      { label: "00:05", value: "300" },
      { label: "00:10", value: "600" },
      { label: "00:15", value: "900" },
      { label: "00:20", value: "1200" },
      { label: "00:25", value: "1500" },
      { label: "00:30", value: "1800" },
      { label: "00:35", value: "2100" },  
      { label: "00:40", value: "2400" },  
      { label: "00:45", value: "2700" },
      { label: "00:50", value: "3000" },
      { label: "00:55", value: "3300" },  
      { label: "01:00", value: "3600" },
      { label: "01:30", value: "5400" },
      { label: "02:00", value: "7200" },
      { label: "02:30", value: "9000" },
      { label: "03:00", value: "10800" },
    ];

    return (
      <>
        {
          isCoursePublish ? (
            <>
              <div className="msg-notification">
                Please choose an end date and time
              </div>

              <FormField
                className="add-date"
                type={FormDateRangePicker}
                name="endDate"
                value={standard.endDate}
                onChange={handleChange}
                timePicker={true}
                size={50}
              />
              {alert && <div style={{color: "red"}}>End date cannot be less than start date </div>}
            </>) :(
              <>
            <Row>
              <Col md={12}>
                <FormField
                  style={{ backgroundcolor: "#764ba2", color: "#000000" }}
                  className="add-date"
                  type={FormDateRangePicker}
                  name="endDate"
                  value={standard.endDate}
                  onChange={handleChange}
                  timePicker={true}
                  size={50}
                />
                {alert && <div style={{color: "red"}}>End date cannot be less than start date </div>}
              </Col>
              
            </Row>
            <Row>
              <Col md={7}>
                <Button
                  className={`cert-toggle-container ${summary ? "enabled" : ""}`}
                  onClick={toggleSummary}
                >
                  <div className="button-content">
                    <span>Summary</span>
                    <div className={`toggle-switch ${summary ? "on" : ""}`}>
                      <div className="toggle-circle" />
                    </div>
                  </div>
                </Button>

              </Col>
               <Col md={5}>
                <FormField
                 className="publish-btns"
                  type={Select}
                  name="attempt"
                  options={options}
                  onChange={handleChange}
                  value={standard.attempt}
                  placeholder="Attempts"
                  required
                // disabled={props.editdivSub}
                />
              </Col>
            </Row>
            </>)}

        {isCoursePublish ? (
          <>
            <Row className="my-3">
              <Col>
                <Button
                  className={`cert-toggle-container ${download ? "enabled" : ""}`}
                  onClick={toggleDownload}
                >
                  Download
                  <div className={`toggle-switch ${download ? "on" : ""}`}>
                    <div className="toggle-circle" />
                  </div>
                </Button>
              </Col>
              <Col>
                <Button
                  className={`cert-toggle-container ${seekable ? "enabled" : ""}`}
                  onClick={toggleSeekable}
                >
                  Seekable
                  <div className={`toggle-switch ${seekable ? "on" : ""}`}>
                    <div className="toggle-circle" />
                  </div>
                </Button>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Button className="publish-btn" onClick={coursePublish} disabled={!standard.endDate}>
                
                  <span>Course Publish</span>
                </Button>
              </Col>
              <Col md={6}>
                <Button className="publish-btn" onClick={handleCancel}>
                  Cancel
                </Button>
              </Col>
            </Row>
          </>
        ) :
          <>
           
            <Row>
             
              <Col md={7}>
                <Button
                  className={`cert-toggle-container ${timeSettings ? "enabled" : ""}`}
                  onClick={toggleTimeSettings}
                >
                  <div className="button-content">
                    <span>Time Settings</span>
                    <div className={`toggle-switch ${timeSettings ? "on" : ""}`}>
                      <div className="toggle-circle" />
                    </div>
                  </div>
                </Button>
              </Col>
               {duration ? (
                <Col md={5}> 
                 <FormField
                  className="add-opt"
                  type={Select}
                  name="duration"
                  options={durations}
                  onChange={handleChange}
                  value={standard.duration}
                  placeholder="Duration"
                  required
                // disabled={props.editdivSub}
                />
                </Col>
            ) : null}
            </Row>
           
            <Row>
              <Col md={6}>
                <Button className="publish-btn" onClick={testPublish} disabled={!standard.endDate}>
                  <span>Test Publish</span>
                </Button>
              </Col>
              <Col md={6}>
                <Button className="publish-btn" onClick={handleCancel}>
                  Cancel
                </Button>
              </Col>
            </Row>
          </>}

      </>
    );
  };

const renderFooter = () => (
  <div className="footer-container">
    <div className="footer">
      {[selectedCourse, standard.endDate, isPublish].map((completed, idx, arr) => (
        <div className="circle-group" key={idx}>
          <div className={`circle ${completed ? "completed" : ""}`}>
            {completed ? "✓" : idx + 1}
          </div>

          {/* connector only if not last circle */}
          {idx < arr.length - 1 && (
            <div
              className={`connector ${
                completed && arr[idx + 1] ? "active" : ""
              }`}
            />
          )}
        </div>
      ))}
    </div>
  </div>
);


  // --- Main Render ---
  return (
  <>
    <StyledChatInterface>
      <StyledChatHeader>
      <IconBotSimplifi />
        <span className="heading-title">{props.ctx_labels.singular.simplifAi}</span>
        <RefreshIcon onClick={handleCancel} />
        <IconClosed style ={{color: "white"}} onClick={props.onClose}/>
      </StyledChatHeader>

      <div className="bottom-to-top-container">
  {/* Chat interface - shows only if nothing is published yet */}
  {!isPublish && (
    <>
      <StyledChatMessages>
        Hello! I’m SimplifAi, here to help you publish courses and assessments quickly and easily!
      </StyledChatMessages>

      <Row className="row-details">
        <Col md={6} className="mb-3">
          {!isTestPublish && <Button className="publish-btn" onClick={handleCourseClick}>Course Publish</Button>}
          {isCoursePublish && <div className="txt-msg">Great! Let's publish a Course.</div>}
        </Col>
        <Col md={6} className="mb-3">
          {!isCoursePublish && <Button className="publish-btn" onClick={handleTestClick}>Test Publish</Button>}
          {isTestPublish && <div className="txt-msg">Great! Let's publish an Assessment.</div>}
        </Col>
      </Row>

      {(isCoursePublish || isTestPublish) && (
        <Row>
          <Col md={12}>{handleCombination()}</Col>
        </Row>
      )}

      {showList  && (
        <CourseTestList
          isTestPublish={isTestPublish}
          isCoursePublish={isCoursePublish}
          courses={courseList}
          selectedCourse={handleSelectedCourse}
          pubType={publishType}
          allCourses={allCourses}
          CourseName={handleCourseName}
          seeMore={seeMore}
          handleSeeMore={setPageIndex}
        />
      )}

      {selectedCourse && handleSelectBatch()}
      {(standard.batch || standard.class) && renderCertificate()}
    </>
  )}

  {/* Publish Card - shows only after successful publish */}
  {isPublish && publishDetails && (
    <>
    {isCoursePublish ?(<div>Here you go! Your course has been published.</div>) : (<div>Here you go! Your test has been published.</div>)}
    <div className="publish-card">
    <p style={{ display: "flex", alignItems: "center", gap: "6px" }}>
  <strong>{publishDetails.title}</strong>
  <IconCertified />
</p>
      <p>Published Date - {publishDetails.fromDate}</p>
      <p>End Date - {publishDetails.endDate}</p>
      <p>Standard - {publishDetails.standard}</p>
      <p>Subject - {publishDetails.subject}</p>
      <p>Audience - {publishDetails.audience}</p>
     {isCoursePublish && (<p>Release Mode - {"ALL"}</p>)}
    </div>
    </>
  )}
</div>

      {renderFooter()}
    </StyledChatInterface>

  </>
);

}

export default withLabelsContext(withApiContext(withUserContext(SimplifiBot)));
